import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import React from "react";

import NotFound from "./pages/NotFound";

import Footer from "./pages/Footer";

const theme = createTheme({
  typography: {
    fontFamily: ["IBM"],
  },
});

function AppContent() {
  const location = useLocation();
  return (
    <>
      {![
        "/",
        "/admin",
        "/admin/manage-stores",
        "/admin/manage-user",
        "/admin/manage-articles",
        "/admin/manage-siteinfo",
        "/admin/support",
      ].includes(location.pathname) && <Header />}
      <Routes>
        <Route path="/" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {![
        "/",
        "/admin",
        "/admin/manage-stores",
        "/admin/manage-user",
        "/admin/manage-articles",
        "/admin/manage-siteinfo",
        "/admin/support",
      ].includes(location.pathname) && <Footer />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
